var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.592 9.168c-.656 0-1.678-.764-2.74-.764-1.412 0-2.704.863-3.432 2.129-1.464 2.542-.377 6.298 1.051 8.364.701 1.006 1.527 2.138 2.623 2.102 1.051-.045 1.446-.683 2.722-.683 1.267 0 1.626.683 2.74.656 1.132-.018 1.851-1.024 2.542-2.039a9.015 9.015 0 0 0 1.15-2.363c-.027-.009-2.2-.844-2.228-3.36-.018-2.102 1.716-3.108 1.797-3.153-.988-1.446-2.506-1.608-3.036-1.644-1.384-.108-2.542.755-3.189.755",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.651 2.954c.869-.323 1.437.154 1.27 1.066-.168.912-1.009 1.913-1.878 2.237-.869.323-1.437-.154-1.27-1.066.169-.912 1.009-1.913 1.878-2.237"
  })));
};
export { SvgApple as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYThmOTMyZjdlNTNlOWZiZTZiNDQzZDMzZDkzZjVjYTMuc3ZnIjs=";